import { render, staticRenderFns } from "./navigation-tree-content.vue?vue&type=template&id=21942db0&"
import script from "./navigation-tree-content.vue?vue&type=script&lang=js&"
export * from "./navigation-tree-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports